<div class="announcements">
  <div class="row">
    <div class="filter-container col-md-2">
      <div class="filter-buttons">
        <button
          *ngFor="let filter of switchFilterStatuses"
          [ngClass]="
            switchFilterStatus === filter.value
              ? filter.styleClass + '--active'
              : filter.styleClass
          "
          (click)="onApplyClick(dt, filter.value)"
          class="status-button"
        >
          {{ getLabel(filter.isInModeration, filter.label) }}
        </button>
      </div>
      <div class="filter-inputs">
        <div class="filter-inputs-container">
          <div class="input-header">{{ 'label.Website' | translate }}</div>
          <div>
            <select [(ngModel)]="filterPagingWrapper.filter.providerWebsiteId">
              <option
                *ngFor="let item of providerWebsiteList"
                [value]="item.value"
              >
                {{ item.text }}
              </option>
            </select>
          </div>
        </div>
        <div class="filter-inputs-container">
          <div class="input-header">{{ 'label.ID' | translate }}</div>
          <div>
            <input type="number" [(ngModel)]="filterPagingWrapper.filter.id" />
          </div>
        </div>
        <div class="filter-inputs-container">
          <div class="input-header">{{ 'label.Customer' | translate }}</div>
          <p-autoComplete
            [(ngModel)]="filterPagingWrapper.filter.selectedCustomerIdList"
            [suggestions]="customerList"
            (completeMethod)="filterCustomer($event)"
            [minLength]="1"
            fluid
            multiple
          >
            <ng-template let-customer pTemplate="item">
              <span>{{ customer.label }}</span>
            </ng-template>
          </p-autoComplete>
        </div>
        <div class="filter-inputs-container">
          <div class="input-header">{{ 'label.Title' | translate }}</div>
          <div>
            <input
              type="text"
              [(ngModel)]="filterPagingWrapper.filter.announcementTitle"
            />
            <hr-field-state-marker
              [field]="field?.title"
            ></hr-field-state-marker>
          </div>
        </div>
        <div class="filter-inputs-container">
          <div class="input-header">
            {{ 'label.ApplicationEmail' | translate }}
          </div>
          <div>
            <input
              type="text"
              [(ngModel)]="filterPagingWrapper.filter.applicationEmail"
            />
          </div>
        </div>
        <div class="filter-inputs-container">
          <div class="input-header">{{ 'label.PublishDate' | translate }}</div>
          <div>
            <hr-date-range-picker
              class="date-picker"
              [dateFormat]="specialDateFormat"
              [maxStartDate]="currentDate"
              [maxEndDate]="currentDate"
              [style]="{ width: '100%', 'min-width': '5em', height: '38px', border: '1px solid #ddd',}"
              [(ngModel)]="filterPagingWrapper.filter.publishDate"
            ></hr-date-range-picker>
          </div>
        </div>
        <div class="filter-inputs-container">
          <div class="input-header">
            {{ 'label.AccountManager' | translate }}
          </div>
          <div>
            <select
              [ngModel]="
                accountManagers && filterPagingWrapper.filter.accountManagerId
              "
              (ngModelChange)="
                accountManagers &&
                  (filterPagingWrapper.filter.accountManagerId = $event)
              "
            >
              <option selected></option>
              <option
                *ngFor="let item of accountManagers"
                [value]="item?.adminId"
              >
                {{ item?.fullName }}
              </option>
            </select>
          </div>
        </div>
        <div class="filter-inputs-container">
          <div class="input-header">{{ 'label.Portfolio' | translate }}</div>
          <div>
            <select [(ngModel)]="filterPagingWrapper.filter.portfolioId">
              <option
                *ngFor="let item of portfolios"
                [value]="item.portfolioId"
              >
                {{ item.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="filter-inputs-container">
          <div class="input-header">{{ 'label.ExpireDate' | translate }}</div>
          <div>
            <hr-date-range-picker
              class="date-picker"
              [dateFormat]="specialDateFormat"
              [style]="{ width: '100%', 'min-width': '5em', height: '38px', border: '1px solid #ddd', }"
              [(ngModel)]="filterPagingWrapper.filter.deadlineDate"
            ></hr-date-range-picker>
          </div>
        </div>
        <div class="filter-inputs-container">
          <div class="input-header">
            {{ 'label.ModerationStatus' | translate }}
          </div>
          <div>
            <select [(ngModel)]="filterPagingWrapper.filter.moderationStatus">
              <option
                *ngFor="let item of switchModerationStatuses"
                [ngValue]="item.value"
              >
                {{ item.label }}
              </option>
            </select>
          </div>
        </div>
        <div class="filter-inputs-container">
          <div class="input-header">{{ 'label.OnWebsite' | translate }}</div>
          <div>
            <select [(ngModel)]="filterPagingWrapper.filter.onWebsite">
              <option
                *ngFor="let item of switchOnWebsiteStatuses"
                [ngValue]="item.value"
              >
                {{ item.label }}
              </option>
            </select>
          </div>
        </div>
        <div class="filter-inputs-container">
          <div class="input-header">{{ 'label.Logs' | translate }}</div>
          <div>
            <hr-date-range-picker
              class="date-picker"
              [dateFormat]="specialDateFormat"
              [style]="{width: '100%', 'min-width': '5em', height: '38px', border: '1px solid #ddd', }"
              [(ngModel)]="filterPagingWrapper.filter.logDate"
            ></hr-date-range-picker>
          </div>
        </div>
      </div>
      <div class="bottom-buttons">
        <button class="apply" (click)="onApplyClick(dt)">
          {{ 'label.Filter' | translate }}
        </button>
        <button class="clear" (click)="onClearClick()">
          {{ 'label.Clear' | translate }}
        </button>
      </div>
    </div>
    <div class="table-header">
      <div class="future-announcements">
        <a
          [routerLink]="['/announcements/future-announcements']"
          style="float: right"
          >{{ 'label.FutureAnnouncements' | translate }}</a
        >
      </div>
      <p-table
        [value]="announcementList"
        #dt
        [rowHover]="false"
        [lazy]="true"
        [paginator]="true"
        [rows]="pageSize"
        showGridlines
        (onLazyLoad)="onLoad($event)"
        [totalRecords]="totalRecords"
        expandableRows="true"
        (onRowExpand)="onExpandClick($event)"
        dataKey="announcementId"
      >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th style="max-width: 10%" [pSortableColumn]="'title'">
              {{ 'label.Title' | translate }}
            </th>
            <th style="width: 11%" [pSortableColumn]="'customerName'">
              {{ 'label.CompanyNameList' | translate }}
            </th>
            <th style="width: 12%" [pSortableColumn]="'publisher'">
              {{ 'label.AddedBy' | translate }}
            </th>
            <th style="width: 11%" [pSortableColumn]="'accountManagerFullName'">
              {{ 'label.AccountManager' | translate }}
            </th>
            <th style="width: 11%" [pSortableColumn]="'publishDate'">
              {{ 'label.PublishDate' | translate }}
            </th>
            <th style="width: 6%" [pSortableColumn]="'deadlineDate'">
              {{ 'label.Deadline' | translate }}
            </th>
            <th style="width: 6%" [pSortableColumn]="'status'">
              {{ 'label.Status' | translate }}
            </th>
            <th style="width: 4%" [pSortableColumn]="'viewCount'">
              {{ 'label.Views' | translate }}
            </th>
            <th style="width: 13%"></th>
          </tr>
        </ng-template>

        <ng-template
          #body
          let-announcement
          let-expanded="expanded"
          let-columns="columns"
        >
          <tr>
            <td
              [ngStyle]="{
                'border-left': '4px solid ' + getBorderColors(announcement),

              }"
            >
              <a href="#" [pRowToggler]="announcement" class="arrow-icon">
                <ng-container
                  *ngIf="!expanded; else arrowUp"
                  class="arrow-down"
                >
                  <svg-icon src="assets/img/arrow_down.svg"></svg-icon>
                </ng-container>
                <ng-template #arrowUp>
                  <svg-icon src="assets/img/arrow_up.svg"></svg-icon>
                </ng-template>
              </a>
              <span style="font-size: 15px">{{ announcement.title }}</span>
            </td>
            <td>
              <span style="font-size: 15px">{{
                announcement.customerName
              }}</span>
            </td>
            <td>
              <span style="font-size: 15px">{{ announcement.publisher }}</span>
            </td>
            <td>
              <span style="font-size: 15px">{{
                announcement.accountManagerFullName
              }}</span>
            </td>
            <td>
              <span style="font-size: 15px">{{
                announcement.publishDate | date : 'dd/MM/yy h:mm a'
              }}</span>
            </td>
            <td>
              <span style="font-size: 15px">{{
                announcement.deadlineDate | date : 'dd/MM/yy'
              }}</span>
            </td>
            <td>
              <span style="font-size: 15px">{{ announcement.status }}</span>
            </td>
            <td>
              <span style="font-size: 15px">{{ announcement.viewCount }}</span>
            </td>
            <td>
              <div class="announcement-buttons">
                <a
                  *ngIf="
                    announcement.hasPendingChanges ||
                    announcement.announcementStatusId ===
                      announcementStatus.Pending
                  "
                  [routerLink]="[
                    '/announcements/moderation/' + announcement.announcementId
                  ]"
                >
                  <span class="moderation-icon">
                    <svg-icon src="assets/img/moderation.svg"></svg-icon>
                    <span>{{ 'label.Moderation' | translate }}</span>
                  </span>
                </a>
                <span
                  (click)="onDeactivateClick(announcement.announcementId)"
                  *ngIf="
                    announcement.announcementStatusId ==
                    SwitchFilterStatus.Active
                  "
                >
                  <a class="deactivate-icon">
                    <svg-icon src="assets/img/deactivate.svg"></svg-icon>

                    <span>{{ 'label.Deactivate' | translate }}</span>
                  </a>
                </span>
                <span
                  (click)="onActivateClick(announcement.announcementId)"
                  *ngIf="
                    announcement.announcementStatusId ==
                    SwitchFilterStatus.Deactived
                  "
                >
                  <a class="activate-icon">
                    <svg-icon src="assets/img/activate.svg"></svg-icon>
                    <span>{{ 'label.Activate' | translate }}</span>
                  </a>
                </span>
                <span
                  (click)="onAnnouncementCancel(announcement.announcementId)"
                  *ngIf="
                    (announcement.announcementStatusId ==
                      SwitchFilterStatus.Active ||
                      announcement.announcementStatusId ==
                        SwitchFilterStatus.Deactived) &&
                    hasAnnouncementCancelPermission
                  "
                >
                  <a class="cancel-icon">
                    <svg-icon
                      src="assets/img/cancel_announcement.svg"
                    ></svg-icon>
                    <span>{{ 'label.Cancel' | translate }}</span></a
                  >
                </span>
                <span
                  (click)="
                    onToggleAnnouncementCapture(
                      announcement.announcementId,
                      announcement.hasCaptureCv
                    )
                  "
                >
                  <a class="cancel-icon">
                    <svg-icon
                      [src]="
                        announcement.hasCaptureCv
                          ? 'assets/img/deactivate.svg'
                          : 'assets/img/activate.svg'
                      "
                    ></svg-icon>
                    <span>{{
                      announcement.hasCaptureCv
                        ? ('label.DisableCapture' | translate)
                        : ('label.EnableCapture' | translate)
                    }}</span></a
                  >
                </span>
              </div>
            </td>
          </tr>
        </ng-template>

        <!-- <p-column expander="true" styleClass="col-icon" [style]="{width:'2%'}"></p-column>
                <p-column field="title" title="Title" header="{{'Title' | translate}}" [style]="{width:'10%'}" [sortable]="true">
                </p-column>
                <p-column field="customerName" header="{{'CustomerName' | translate}}" [style]="{width:'11%'}" [sortable]="true">
                </p-column>
                <p-column field="publisher" header="{{'AddedBy' | translate}}" [style]="{width:'12%'}" [sortable]="true">
                </p-column>

                <p-column field="publishDate" header="{{'PublishDate' | translate}}" [style]="{width:'11%'}" [sortable]="true">
                    <ng-template let-col let-announcement="rowData" pTemplate="body">
                        <span>{{announcement[col.field] | date: 'dd/MM/yy h:mm a' }}</span>
                    </ng-template>
                </p-column>

                <p-column field="deadlineDate" header="{{'Deadline' | translate}}" [style]="{width:'6%'}" [sortable]="true">
                    <ng-template let-col let-announcement="rowData" pTemplate="body">
                        <span>{{announcement[col.field] | date: 'dd/MM/yy'}}</span>
                    </ng-template>
                </p-column>

                <p-column field="status" header="{{'Status' | translate}}" [style]="{width:'6%'}" [sortable]="true">
                </p-column>

                <p-column field="viewCount" header="{{'Views' | translate}}" [style]="{width:'4%'}" [sortable]="true">
                </p-column>
                <p-column [style]="{width:'13%'}">
                    <ng-template let-col let-subscriber="rowData" pTemplate="body">
                        <span *ngIf="switchFilterStatus != SwitchFilterStatus.Expired && switchFilterStatus != SwitchFilterStatus.Canceled">
                            <a style="color:#2d8bce; text-decoration: underline;">{{"Edit" | translate }} </a>
                        </span>
                        <span (click)="onDeactivateClick(subscriber.announcementId)" *ngIf="switchFilterStatus == SwitchFilterStatus.Active">
                            <a style="color:#2d8bce; text-decoration: underline;">{{"Deactivate" | translate }} </a>
                        </span>
                        <span (click)="onActivateClick(subscriber.announcementId)" *ngIf="switchFilterStatus == SwitchFilterStatus.Deactived">
                            <a style="color:#2d8bce; text-decoration: underline;">{{"Activate" | translate }} </a>
                        </span>
                        <span (click)="onAnnouncementCancel(subscriber.announcementId)" *ngIf="(switchFilterStatus == SwitchFilterStatus.Active || switchFilterStatus == SwitchFilterStatus.Deactived) && hasAnnouncementCancelPermission">
                            <a style="color:#2d8bce; text-decoration: underline;">{{"Cancel" | translate }}</a>
                        </span>
                    </ng-template>
                </p-column> -->
        <ng-template let-announcement #expandedrow>
          <tr>
            <td colspan="9">
              <div
                class="ui-grid ui-grid-responsive ui-fluid"
                style="padding: 20px"
              >
                <hr-announcement-details
                  [announcementDetails]="announcement?.announcementDetails"
                ></hr-announcement-details>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="9">
              {{ 'message.NoRecordsFound' | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
